module.exports = __webpack_public_path__ + "static/media/62.59eea493.jpg";